// hooks/useFetchTransactions.ts
import { useState, useEffect } from "react";
import axios from "axios";
import qs from "qs";
import { useAuth0 } from "@auth0/auth0-react";

const apiUrl = process.env.REACT_APP_API_URL;

const useGetWithdrawal = (
  token: any,
  page: any,
  pageSize: any,
  filter: any
) => {

    const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const [withdrawal, setWithdrawal] = useState< any>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTransactions = async () => {
      setLoading(true);
      setError(null);

      try {
        // Construir query string
        const queryParams = qs.stringify({
          ...filter,
          page: page,
          pageSize: pageSize,
        }, { arrayFormat: 'brackets' });

              const tk = await getAccessTokenSilently();


        const response = await axios.get<any>(
          `${apiUrl}/api/v1/admin/withdrawal/get?${queryParams}`,
          {
            headers: {
              Authorization: `Bearer ${tk}`,
              "Content-Type": "application/json",
            },
          }
        );

        setWithdrawal(response?.data);
      } catch (err: any) {
        setError(err?.message || "Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchTransactions();
  }, [ page, pageSize, filter]);

  return { withdrawal, loading, error };
};

export default useGetWithdrawal;



